import { useEffect, useState } from 'react'
import { FirebaseQuestions } from '../@types/FirebaseQuestions'
import { QuestionType } from '../@types/QuestionType'
import { database } from '../services/firebase'
import useAuth from './useAuth'

export function useRoom(roomId: string) {
    const [questions, setQuestions] = useState<QuestionType[]>([])
    const [title, setTitle] = useState('')
    const { user } = useAuth()

    useEffect(() => {
        const roomRef = database.ref(`rooms/${roomId}`)

        roomRef.on('value', room => {
            const databaseRoom = room.val()
            const firebaseQuestions: FirebaseQuestions =
                databaseRoom.questions ?? {}
            const parsedQuestions = Object.entries(firebaseQuestions).map(
                ([key, value]) => {
                    return {
                        id: key,
                        content: value.content,
                        author: value.author,
                        isAnswered: value.isAnswered,
                        isHighlighted: value.isHighlighted,
                        likeCount: Object.values(value.likes ?? {}).length,
                        likeId: Object.entries(value.likes ?? {}).find(
                            ([key, like]) => like.authorId === user?.id
                        )?.[0]
                    }
                }
            )

            const questinSorted = parsedQuestions.sort(
                (a, b) => b.likeCount - a.likeCount
            )

            setTitle(databaseRoom.title)
            setQuestions(questinSorted)

            return () => {
                roomRef.off('value')
            }
        })
    }, [roomId, user?.id])

    return { questions, title }
}
